import { useAppSelector } from '../../redux/_reduxHooks'
import { WebDozentDto } from '../../types/webTypes/WebDozentDto'

export const EventDocent = () => {
  const webEventTopicData = useAppSelector((state) => state.web.selectedNwTopic)

  // Returned den vollen Namen (Vorname + Nachname) + Titel, wenn vorhande
  const docentFullName = (dozent: WebDozentDto) => {
    return `${dozent.titel ? dozent.titel : ''} ${dozent.vorname} ${dozent.nachname}`
  }

  // Vita Text auf max. 140 Zeichen kürzen, aber volle Wörter nicht abschneiden
  const truncateVitaText = (vitaText: string | null) => {
    const maxLength = 140

    if (!vitaText) {
      return
    }
    if (vitaText.length <= maxLength) {
      return vitaText
    }

    const words = vitaText.split(' ')
    let truncated = ''

    for (let i = 0; i < words.length; i++) {
      if ((truncated + words[i]).length <= maxLength) {
        truncated += words[i] + ' '
      } else {
        break
      }
    }

    return truncated.trim() + ' ...'
  }

  // Liste von uniquen Dozenten zurückgeben
  const uniqueDocents = webEventTopicData?.seminarList.reduce((acc, seminar) => {
    seminar.dozenten.forEach((dozent) => {
      if (!acc.some((existingDozent) => existingDozent.id === dozent.id)) {
        acc.push(dozent)
      }
    })
    return acc
  }, [] as WebDozentDto[])

  // Gibt Titel der Dozentinnen/Dozenten zurück, genderspezifisch in Singular und Plurar
  const docentGenderedTitle = (dozentList: WebDozentDto[] | undefined) => {
    if (dozentList !== undefined) {
      if (dozentList.length === 0) {
        return '' // Default string if no docents are available
      }

      let maleCount = 0
      let femaleCount = 0

      dozentList.forEach((dozent) => {
        if (dozent.anrede === 'Herr') {
          maleCount++
        } else if (dozent.anrede === 'Frau') {
          femaleCount++
        } else if (dozent.anrede.trim() === '') {
          // Check for empty or whitespace-only string
          maleCount++
          femaleCount++
        }
      })

      if (maleCount > 0 && femaleCount === 0) {
        return maleCount > 1 ? 'Referenten in diesem Video' : 'Referent in diesem Video'
      } else if (femaleCount > 0 && maleCount === 0) {
        return femaleCount > 1 ? 'Referentinnen in diesem Video' : 'Referentin in diesem Video'
      } else {
        if (maleCount > 0 && femaleCount > 0) {
          return `Referentin${femaleCount > 1 ? 'nen' : ''} und Referent${maleCount > 1 ? 'en' : ''} in diesem Video`
        } else {
          // Handle the case where there are no gender-specific titles available
          return 'Referentinnen und Referent für dieses Thema'
        }
      }
    }
  }

  return (
    <>
      <div className="themendoz">
        <div className="hidden-xs trenner" />
        <div className="col-xs-12">
          <div className="row">
            <div
              style={{
                fontWeight: 'bold',
                fontSize: 'x-large',
                textAlign: 'center',
                marginBottom: '35px',
                marginTop: '15px',
              }}
            >
              {docentGenderedTitle(uniqueDocents)}
            </div>
          </div>
        </div>
        {uniqueDocents?.map((dozent, dozentIndex) => (
          <a key={dozentIndex} className="info" href={`/dozent/${dozent.id}`} title={`Dozentenprofil - ${docentFullName(dozent)}`}>
            <div className="col-xs-12 col-sm-12 panel">
              <div className="row">
                <div className="col-xs-3 col-sm-2 col-md-3">
                  <div className="row">
                    <div className="hovereffect hovereffect3">
                      <img className="img-responsive" src={dozent.bild ?? ''} alt={`${docentFullName(dozent)}`} width="220px" height="294px" />
                      <div className="overlay">
                        <span className="doz-label">{docentFullName(dozent)}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-9 col-sm-10 col-md-9 text-left">
                  <div className="row">
                    <div className="col-xs-12">
                      <div className="h4">{docentFullName(dozent)}</div>
                    </div>
                    <div className="col-xs-12 vita">{truncateVitaText(dozent.vita)}</div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </>
  )
}
